import React from 'react';

const CSSWinner = () => {
  return (
    <svg
      width="28"
      height="17"
      viewBox="0 0 28 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0.0147658C0 0.0491837 11.4352 17.0098 11.45 17C11.4869 16.9779 12.4473 15.5544 12.4399 15.5323C12.4374 15.52 10.0883 12.0192 7.21966 7.75388L2.00683 1.5263e-05H1.00465C0.450613 1.5263e-05 0 0.00739053 0 0.0147658Z"
        fill="white"
      />
      <path
        d="M18.6822 3.21315C15.7643 7.57439 14.8483 8.94619 14.8483 8.96094C14.8483 9.00273 15.8406 10.4507 15.8578 10.4335C15.8726 10.4139 22.6909 0.255669 22.814 0.0663703L22.8559 -7.06309e-06H21.8463H20.8343L18.6822 3.21315Z"
        fill="white"
      />
      <path
        d="M20.588 6.98684C18.0099 10.8318 15.8873 13.9884 15.8725 14.0056C15.8528 14.0278 15.0058 12.774 12.4498 8.93391C10.5809 6.12639 9.03945 3.82531 9.02714 3.82039C9.01236 3.81547 8.54944 3.81301 8.00033 3.81547L7.00061 3.82285L11.4329 10.4188C15.0476 15.7978 15.8701 17.0098 15.8971 16.9828C15.9341 16.9434 27.261 0.073756 27.2757 0.0295044C27.2856 0.00737865 27.0763 3.38726e-06 26.2809 3.38726e-06H25.2763L20.588 6.98684Z"
        fill="white"
      />
    </svg>
  );
};

export default CSSWinner;
